export const MAX_CHARACTER_NAME_LENGTH = 50;